const state = {
  user: {
    name: 'Test User',
    email: 'test@test.com',
    isLoggedIn: !!localStorage.getItem('authToken')
  },
  application: {
    businessInfo: {
      name: '',
      startMonth: '',
      startYear: ''
    },
    loanParams: {
      amountRequested: ''
    }
  },
  welcomeMsg: 'Find the Right Lender for Your Business in 60 Seconds.'
}
export default state
